<template>
  <div class="controlPanel">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="系统日志" name="first">
          <span
            class="childTabs"
            @click="logTypeClick('login')"
            :class="{ activeLink: activeLink == 'login' }"
            >登录日志</span
          >
          <span
            class="childTabs"
            @click="logTypeClick('operate')"
            :class="{ activeLink: activeLink == 'operate' }"
            >操作日志</span
          >
          <span
            class="childTabs"
            @click="logTypeClick('process')"
            :class="{ activeLink: activeLink == 'process' }"
            >生产日志</span
          >
          <span
            class="childTabs"
            @click="logTypeClick('error')"
            :class="{ activeLink: activeLink == 'error' }"
            >错误日志</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button v-if="activeLink == 'error'" type="primary" icon="el-icon-download" size="small"
                @click="tableExport">导出</el-button>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="allLogSearchForm"
        class="demo-form-inline"
        v-if="isMoreSearch"
      >
        <div
          class="searchConditionBox"
          v-if="activeLink == 'login'"
          key="login"
        >
          <el-form-item label="员工" size="small">
            <el-select
              v-model="allLogSearchForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'user', '员工选择', 'allLogSearchForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logStartDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logEndDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="IP" size="small">
            <el-input
              v-model="allLogSearchForm.ip"
              placeholder="IP地址"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
        </div>
        <div
          class="searchConditionBox"
          v-else-if="activeLink == 'process'"
          key="process"
        >
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="allLogSearchForm.id"
              @input="idInputChange($event, 'allLogSearchForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Key" size="small">
            <el-input
              v-model="allLogSearchForm.key"
              placeholder="输入Key"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="allLogSearchForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'user', '员工选择', 'allLogSearchForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单号" size="small">
            <el-select
              v-model="allLogSearchForm.orderId"
              filterable
              remote
              placeholder="工单号前五个字符"
              :remote-method="remoteMethod"
              :loading="processOrdeer.loading"
              @change="orderNumberChange"
              clearable
              :popper-class="
                processOrdeer.proOrderFilterText.length >= 5
                  ? ''
                  : 'proOrderPullHidden'
              "
            >
              <el-option
                v-for="item in pullDownData.productOrderList"
                :key="item.id"
                :label="item.orderNumber"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线体" size="small">
            <el-cascader
              :options="pullDownData.factoryOrgData"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id',
              }"
              :show-all-levels="false"
              v-model="allLogSearchForm.organizationId"
              @change="cascaderChange($event, 'factoryOrgCascader')"
              ref="factoryOrgCascader"
              placeholder="选择所在线体"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select
              v-model="allLogSearchForm.workStationId"
              filterable multiple collapse-tags
              placeholder="选择工序"
              clearable
            >
              <el-option
                v-for="item in pullDownData.workStationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <!-- <el-input
              v-model="allLogSearchForm.errorCode"
              placeholder="错误代码"
              clearable
            ></el-input> -->
            <el-select
              v-model="allLogSearchForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logStartDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logEndDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else key="other">
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="allLogSearchForm.id"
              @input="idInputChange($event, 'allLogSearchForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <!-- <el-input
              v-model="allLogSearchForm.username"
              placeholder="员工姓名"
              clearable
            ></el-input> -->
            <el-select
              v-model="allLogSearchForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'user', '员工选择', 'allLogSearchForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作" size="small">
            <el-input
              v-model="allLogSearchForm.action"
              placeholder="操作行为"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="错误代码"
            size="small"
            v-if="activeLink == 'operate'"
          >
            <el-select
              v-model="allLogSearchForm.returnCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small" v-else>            
            <el-select
              v-model="allLogSearchForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logStartDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="allLogSearchForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="logEndDateTime('allLogSearchForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="IP" size="small">
            <el-input
              v-model="allLogSearchForm.ip"
              placeholder="IP地址"
              clearable
              @keyup.enter.native="getAllLogSearch()"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="APP" size="small">
            <el-input v-model="allLogSearchForm.app" placeholder="APP名称" clearable></el-input>
          </el-form-item>-->
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent">
        <el-table
          stripe
          v-if="activeLink == 'login'"
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          key="login"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="user"
            label="员工"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.user"
                >{{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="app"
            label="客户端"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.app">{{ `${scope.row.app} ${scope.row.appVer}(${scope.row.appBuild})` }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ip"
            label="IP"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="loginTime"
            label="登录时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.loginTime">{{ scope.row.loginTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="logoutTime"
            label="登出时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.logoutTime">{{ scope.row.logoutTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          stripe
          v-else-if="activeLink == 'operate'"
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          key="operate"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="Request ID"
            align="center"
            show-overflow-tooltip
            min-width="120"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="$systemLogDetail(scope.row)">{{
                scope.row.id
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user"
            label="员工"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.user"
                >{{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="action"
            label="操作" width="95px"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="requestIp"
            label="IP"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="requestDateTime"
            label="操作时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.requestDateTime">{{ scope.row.requestDateTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="app"
            label="客户端"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.app">{{ `${scope.row.app} ${scope.row.appVer}(${scope.row.appBuild})` }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="returnCode"
            label="错误代码"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :class="{danger: scope.row.returnCode != 0}">{{ scope.row.returnCode }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="returnMsg"
            label="返回信息"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.returnMsg"
                placement="top"
                :open-delay="300"
              >
                <div class="textOverflow" v-if="scope.row.returnMsg">{{scope.row.returnMsg}}</div>
              </el-tooltip>
              <span v-if="!scope.row.returnMsg">-</span>
            </template>
            </el-table-column>
        </el-table>
        <el-table
          stripe
          v-else-if="activeLink == 'process'"
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          key="process"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="Request ID"
            align="center"
            show-overflow-tooltip
            min-width="120"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="$processLogDetail(scope.row)">{{
                scope.row.id
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="key"
            label="Key"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.key">{{ scope.row.key }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="order"
            label="工单"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.order">{{
                scope.row.order.orderNumber
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="plant"
            label="车间"
            align="center"
            show-overflow-tooltip
            width="90px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.plant">{{ scope.row.plant.name }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organization"
            label="线体"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.organization">{{
                scope.row.organization.name
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="workStation"
            label="工序"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workStation">{{
                scope.row.workStation.name
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user"
            label="员工"
            align="center"
            show-overflow-tooltip
            width="80"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.user"> {{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="requestDateTime"
            label="操作时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.requestDateTime">{{
                scope.row.requestDateTime
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          
          <el-table-column
            prop="requestData"
            label="请求参数"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="300"
              >
                <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.requestData, null, 2) }}</div>
                <div class="textOverflow" v-if="scope.row.requestData">{{scope.row.requestData}}</div>
              </el-tooltip>
              <span v-if="!scope.row.requestData">-</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="returnCode"
            label="错误代码"
            align="center"
            width="90"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :class="{danger: scope.row.returnCode != 0}">{{ scope.row.returnCode }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="returnMsg"
            label="返回信息"
            align="center"
          >          
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.returnMsg"
                placement="top"
                :open-delay="300"
              >
                <div class="textOverflow" v-if="scope.row.returnMsg">{{scope.row.returnMsg}}</div>
              </el-tooltip>
              <span v-if="!scope.row.returnMsg">-</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="userAgent" label="客户端" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.userAgent">{{scope.row.userAgent}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column> -->
        </el-table>
        <el-table
          stripe
          v-else-if="activeLink == 'error'"
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          key="error"
        >
          <el-table-column
            type="index"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            align="center"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="Request ID"
            align="center"
            show-overflow-tooltip
            min-width="120"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="$errorLogDetail(scope.row)">{{
                scope.row.id
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user"
            label="员工"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.user"
                >{{ scope.row.user.name }} ({{scope.row.user.employeeNum}})</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="action"
            label="操作" width="95px"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ip"
            label="IP"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createDateTime"
            label="操作时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createDateTime">{{ scope.row.createDateTime }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="app"
            label="客户端"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.app">{{ `${scope.row.app} ${scope.row.appVer}(${scope.row.appBuild})` }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorCode"
            label="错误代码"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :class="{danger: scope.row.errorCode != 0}">{{ scope.row.errorCode }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorMsg"
            label="错误信息"
            align="center"
          >          
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.errorMsg"
                placement="top"
                :open-delay="300"
              >
                <div class="textOverflow" v-if="scope.row.errorMsg">{{scope.row.errorMsg}}</div>
              </el-tooltip>
              <span v-if="!scope.row.errorMsg">-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getAllLogSearch"
        ></pagination>
      </div>
    </div>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiLoginLogSearch,
  apiOperateLogSearch,
  apiProcessLogSearch,
  apiErrorLogSearch,
  apiWorkStationList,
} from "@/api/systemLog.js";
import {
  apiProductionOrderList,
  apiFactoryOrgShow,
} from "@/api/productSystem.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/systemLog", subTabs: { activeLink: ["login", "operate", "process", "error"] } },
  components: {
    pagination,
    orderTableSelect
  },
  data() {
    return {
      activeLink: "login",
      isMoreSearch: false,
      allLogSearchForm: {},
      pullDownData: {
        userList: [],
        processUserList: [],
        productOrderList: [],
        factoryOrgData: [],
        workStationList: [],
      },
      tableData: [],      
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      processOrdeer: {
        proOrderFilterText: "",
        loading: false,
        // 组装工单延时加载
        timer: "",
      },
    };
  },
  methods: {
    // 系统日志子级标签点击
    logTypeClick(logName) {
      this.activeLink = logName;
      this.pagination.currentPage = 1;
      this.$moreSearchStyle();
      // if (logName == "process") {
      //   this.getAllLogSearch("", this.getFactoryOrg);
      // } else {
        this.getAllLogSearch();
      // }
    },
    tableExport() {      
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {        
        this.pagination.currentPage = 1;
        const res = await apiErrorLogSearch({
          ...this.allLogSearchForm,
          export: true
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    // 表格日志数据
    async getAllLogSearch(remove, callback) {
      if (remove != "noRemove") {
        this.tableData = [];
      }
      let res = {};
      if (this.activeLink == "login") {
        res = await apiLoginLogSearch({
          ...this.allLogSearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          orderBy: this.orderBy,          
          desc: this.desc
        });
      } else if (this.activeLink == "operate") {
        res = await apiOperateLogSearch({
          ...this.allLogSearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        });
      } else if (this.activeLink == "process") {
        res = await apiProcessLogSearch({
          ...this.allLogSearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        });
      } else if (this.activeLink == "error") {
        res = await apiErrorLogSearch({
          ...this.allLogSearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        });
      }
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 判断id只能输入数字
    idInputChange(value, formName) {
      this.$set(this[formName], "id", this.$formatPositive(value));
    },
    // 组装工单数据请求
    remoteMethod(query) {
      let processOrdeer = this.processOrdeer;
      clearTimeout(processOrdeer.timer);
      processOrdeer.proOrderFilterText = query;
      if (query.length >= 5) {
        if (processOrdeer.loading) return;
        processOrdeer.loading = true;
        processOrdeer.timer = setTimeout(async () => {
          const res = await apiProductionOrderList({
            orderNumber: query,
            status: ["PRODUCTION"],
          });
          if (res.code == 0) {
            processOrdeer.loading = false;
            this.pullDownData.productOrderList = res.data;
          }
        }, 1000);
      } else {
        processOrdeer.loading = false;
        this.pullDownData.productOrderList = [];
      }
    },
    // 组装工单改变
    orderNumberChange(value) {
      if (value) {
        this.getWorkStationList(value);
      } else {
        this.pullDownData.productOrderList = [];
        this.pullDownData.workStationList = [];
        this.$set(this.allLogSearchForm, "workStationId", undefined);
      }
    },
    // 工序SOP数据请求
    async getWorkStationList(value) {
      const res = await apiWorkStationList({
        orderId: value,
      });
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    // 线体
    async getFactoryOrg() {
      const res = await apiFactoryOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.pullDownData.factoryOrgData = res.data.children;
      }
    },
    // 开始日期
    logStartDateTime(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].endDateTime = this[formName].startDateTime;
      }
    },
    // 结束日期
    logEndDateTime(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].startDateTime = this[formName].endDateTime;
      }
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      // if(origin == "allLogSearchForm") {
      //   this.$set(this.allLogSearchForm, `${orderName + "Id"}`, selectRow.id);
      //   this.$set(this.pullDownData, `processUserList`, [selectRow]);
      // } else {
        this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      // }
    },
    // 清除查询
    onClear() {
      this.pagination.currentPage = 1;
      if (this.activeLink == "process") {
        this.allLogSearchForm = {};
        this.orderNumberChange();
      } else {
        this.allLogSearchForm = {};
        this.getAllLogSearch();
      }
    },
    // 确认查询
    onSearch() {
      this.pagination.currentPage = 1;
      this.getAllLogSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getAllLogSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getAllLogSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getAllLogSearch();
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    callback() {
      this.getFactoryOrg();
      this.getWorkStationList();
    }
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    this.getAllLogSearch("", this.callback);
  },
  deactivated() {
    window.onresize = "";
  },
};
</script>

<style lang="less">
</style>